import { Link } from "react-router-dom";
import { ScrollReveal } from "@/components/base/ScrollAnimations";

export default function ProgramsHero() {
  return (
    <section className="relative min-h-[420px] md:min-h-[520px] lg:min-h-[600px] flex items-center justify-center overflow-hidden bg-tie-navy">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern textile innovation lab with fabric samples hanging on display and testing equipment, warm ambient lighting in cream beige and earth tones, professional corporate environment, innovation workspace aesthetic, clean organized laboratory setting, no blue no green colors, horizontal composition"
          alt=""
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-tie-navy/70 via-tie-navy/50 to-tie-navy/90" />
      </div>

      {/* Decorative thread lines */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-[0.04]">
        <div className="absolute top-0 left-[25%] w-px h-full bg-white" />
        <div className="absolute top-0 left-[50%] w-px h-full bg-white" />
        <div className="absolute top-0 left-[75%] w-px h-full bg-white" />
        <div className="absolute top-[40%] left-0 w-full h-px bg-white" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-24 pb-12 md:pb-16">
        <div className="max-w-4xl mx-auto text-center">
          <ScrollReveal>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/20 mb-5 md:mb-6">
              <span className="w-2 h-2 rounded-full bg-tie-teal-light animate-pulse" />
              <span className="text-xs md:text-sm text-white/80 font-medium tracking-wide uppercase">
                Programmes & Wings
              </span>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={100}>
            <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              Four Wings. One Mission. <br className="hidden md:block" />
              Institutionalizing Innovation.
            </h1>
          </ScrollReveal>

          <ScrollReveal delay={200}>
            <p className="mt-5 md:mt-6 text-base md:text-lg lg:text-xl text-white/70 max-w-3xl mx-auto leading-relaxed">
              TIE operates through four interconnected wings - Innovation,
              Research, Readiness & Recognition, and Expo - that together cover
              the complete innovation lifecycle from factory floor to global
              market.
            </p>
          </ScrollReveal>

          <ScrollReveal delay={350}>
            <div className="mt-7 md:mt-8 flex flex-col sm:flex-row gap-3 justify-center">
              <Link
                to="/collaborate"
                className="inline-flex items-center justify-center px-7 py-3.5 rounded-full bg-tie-teal text-white font-medium text-sm hover:bg-tie-teal-dark transition-all duration-300 whitespace-nowrap"
              >
                Join a Programme
                <i className="ri-arrow-right-line ml-2" />
              </Link>
              <a
                href="#wings"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector("#wings")?.scrollIntoView({ behavior: "smooth" });
                }}
                className="inline-flex items-center justify-center px-7 py-3.5 rounded-full bg-white/10 text-white border border-white/30 font-medium text-sm hover:bg-white/20 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Explore the Wings
                <i className="ri-arrow-down-line ml-2" />
              </a>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}